import { CreditReviewDetailsTabs } from "globalConstants";
import {
	creditReviewPermissionSet,
	notesViewPermissionSet,
	hasPermissions,
} from "helpers";
const {
	MerchantInformation,
	RiskExposureCalculator,
	ExecutiveSummary,
	MerchantNotes,
} = CreditReviewDetailsTabs;

export const creditReviewDetailsTabs = [
	{
		to: MerchantInformation.name,
		eventKey: MerchantInformation.name,
		label: MerchantInformation.displayName,
		requiredPermissions: creditReviewPermissionSet,
	},
	{
		to: RiskExposureCalculator.name,
		eventKey: RiskExposureCalculator.name,
		label: RiskExposureCalculator.displayName,
		requiredPermissions: creditReviewPermissionSet,
	},
	{
		to: ExecutiveSummary.name,
		eventKey: ExecutiveSummary.name,
		label: ExecutiveSummary.displayName,
		requiredPermissions: creditReviewPermissionSet,
	},
	{
		to: MerchantNotes.name,
		eventKey: MerchantNotes.name,
		label: MerchantNotes.displayName,
		requiredPermissions: creditReviewPermissionSet
			? notesViewPermissionSet
			: creditReviewPermissionSet,
	},
];

export const getCreditReviewDetailsTabsPaths = () =>
	creditReviewDetailsTabs
		.filter(tab => hasPermissions(tab?.requiredPermissions))
		.map(tab => tab?.to);
